var _defs, _rect, _path, _g, _g2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVbSizefitIllustrations12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 271.3 306.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        stroke: #231f20;\n      }\n\n      .st0, .st1, .st2 {\n        fill: none;\n        stroke-miterlimit: 10;\n      }\n\n      .st3 {\n        fill: #f1f2f2;\n      }\n\n      .st1 {\n        stroke-dasharray: 1.01 1.01;\n      }\n\n      .st1, .st2 {\n        stroke: #ed1c24;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    width: 271.3,
    height: 306.86
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M188.29,22.15c-6.01,29.68-16.71,61.71-7.44,91.73,7.45,24.12,16.55,47.39,18,72.87,2.4,42.08-6.54,55.81-9.13,97.41"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 48.65,
    y1: 142.69,
    x2: 48.65,
    y2: 143.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 48.65,
    y1: 144.2,
    x2: 48.65,
    y2: 226.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 48.65,
    y1: 226.88,
    x2: 48.65,
    y2: 227.38
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 215.41,
    y1: 143.47,
    x2: 215.41,
    y2: 143.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 215.41,
    y1: 144.98,
    x2: 215.41,
    y2: 227.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 215.41,
    y1: 227.66,
    x2: 215.41,
    y2: 228.16
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.61,22.15c6.01,29.68,16.71,61.71,7.44,91.73-7.45,24.12-16.55,47.39-18,72.87-2.4,42.08,6.54,55.81,9.13,97.41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVbSizefitIllustrations12);
export default __webpack_public_path__ + "static/media/VB_SIZE&FIT_ILLUSTRATIONS-12.a76599969cb4a75806c48ed13ca44f21.svg";
export { ForwardRef as ReactComponent };